import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  computed: {
    ...mapStores(useFileStoreStore)
  },
  methods: {
    async startSearch(searchString) {
      await this.fileStoreStore.search(searchString)
    }
  }
}
